import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";

import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";

export default function PECapstoneOpEdPaper(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Instructions (TL):
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{
                    __html: data.prompt_instructions_tl,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Instructions (EN):
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className="m-0 wysiwyg"
                  dangerouslySetInnerHTML={{
                    __html: data.prompt_instructions_en,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Question:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.prompt }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Feedback Prompt:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className="text-14 m-0 wysiwyg"
                  dangerouslySetInnerHTML={{ __html: data.summary_prompt_en }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {data.title && (
        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography className="text-14 font-bold m-0">
                    Newspaper Header:
                  </Typography>
                  <Divider className="my-16" />
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={4} sm={2}>
                    <Typography className="text-14 font-bold m-0">
                      Title:
                    </Typography>
                    <Typography className="text-14 font-bold m-0">
                      Subtitle:
                    </Typography>
                    {data.subtitle2 && (
                      <Typography className="text-14 font-bold m-0">
                        Subtitle 2:
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={8} sm={10}>
                    <Typography className={`${tl} m-0`} dir={dir}>
                      {data.title}
                    </Typography>
                    <Typography className={`${tl} m-0`} dir={dir}>
                      {data.subtitle1}
                    </Typography>
                    {data.subtitle2 && (
                      <Typography className={`${tl} m-0`} dir={dir}>
                        {data.subtitle2}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}
      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Feedback Response:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.response }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {data.send_email && (
        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography className="text-14 font-bold m-0">
                    E-mail:
                  </Typography>
                  <Divider className="my-16" />
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={4} sm={2}>
                    <Typography className="text-14 font-bold m-0">
                      Send E-mail:
                    </Typography>
                    <Typography className="text-14 font-bold m-0">
                      E-mail Destination:
                    </Typography>
                    <Typography className="text-14 font-bold m-0">
                      E-mail Subject:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} sm={10}>
                    <Typography className="text-14 m-0">
                      {data.send_email ? "true" : "false"}
                    </Typography>
                    <Typography className="text-14 m-0">
                      {data.email_destination}
                    </Typography>
                    <Typography className="text-14 m-0">
                      {data.email_subject}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}
    </div>
  );
}
